import React, { useState, useEffect } from "react";

// @material-ui/styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/layouts/appStyle";
import { useDispatch } from "react-redux";
import {
  changePageTitle,
  notifyShowSuccessMessage,
} from "../../common/actions/CommonActions";
import { LOCALE } from "../../properties/Locale";
import { VacancyAppRepository } from "./VacancyAppRepository";
import BasicInfo from "./vacancyBasicInfo/BasicInfo";
import {
  Paper,
  Grid,
  Typography,
  Tab,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Dialog,
  Divider,
  DialogContent,
  DialogActions,
  TextField,
  Icon,
} from "@material-ui/core";
import Card from "../../common/components/Card/Card";
import CardHeader from "../../common/components/Card/CardHeader";
import CardBody from "../../common/components/Card/CardBody";
import TrainingComponent from "./vacancyProfessionalDevelopment/TrainingComponent";
import EducationalActivityComponent from "./vacancyProfessionalDevelopment/EducationalActivityComponent";
import ProfessionalEventComponent from "./vacancyProfessionalDevelopment/ProfessionalEventComponent";
import AwardsAndRecognitionComponent from "./vacancyProfessionalDevelopment/AwardsAndRecognitionComponent";
import ProfessionalTitleComponent from "./vacancyProfessionalDevelopment/ProfessionalTitleComponent";
import AuthorshipComponent from "./vacancyProfessionalDevelopment/AuthorshipComponent";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Redirect } from "react-router-dom";

const useStyles = makeStyles(styles);

export default function VacancyAppEvaluation(props) {
  const classes = useStyles();

  const dispatch = useDispatch();
  const [vacancyApp, setVacancyApp] = React.useState();
  const [activeStep, setActiveStep] = React.useState(0);
  const [pointsData, setPointsData] = React.useState([0, 0, 0, 0, 0, 0, 0]);
  const [rerender, triggerRerender] = React.useState(0);
  const [additionalDataComment, setAdditionalDataComment] = React.useState();
  const [additionalDataDueDatePlusDays, setAdditionalDataDueDatePlusDays] =
    React.useState(7);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [redirectTo, setRedirectTo] = useState();

  React.useEffect(() => {
    dispatch(changePageTitle(LOCALE.vacancy_evaluation));
    if (props?.match?.params?.vacancyApplicationId) {
      VacancyAppRepository.get(props?.match?.params?.vacancyApplicationId).then(
        (res) => {
          setVacancyApp(res.data);
        }
      );
    }
  }, [dispatch]);

  const nextStep = (data, domain) => {
    console.log("DATA:", data);
    let tmpPoints = pointsData;
    if (domain === "training") {
      tmpPoints[0] = 0;
      data.forEach((element) => {
        tmpPoints[0] = tmpPoints[0] + element.points;
        setPointsData(tmpPoints);
      });
    }
    if (domain === "professional_event") {
      tmpPoints[1] = 0;
      data.forEach((element) => {
        tmpPoints[1] = tmpPoints[1] + element.points;
        setPointsData(tmpPoints);
      });
    }
    if (domain === "educational_activity") {
      tmpPoints[2] = 0;
      data.forEach((element) => {
        tmpPoints[2] = tmpPoints[2] + element.points;
        setPointsData(tmpPoints);
      });
    }
    if (domain === "awards_and_recognitions") {
      tmpPoints[3] = 0;
      data.forEach((element) => {
        tmpPoints[3] = tmpPoints[3] + element.points;
        setPointsData(tmpPoints);
      });
    }
    if (domain === "professional_title") {
      tmpPoints[4] = 0;
      data.forEach((element) => {
        tmpPoints[4] = tmpPoints[4] + element.points;
        setPointsData(tmpPoints);
      });
    }
    if (domain === "authorship") {
      tmpPoints[5] = 0;
      data.forEach((element) => {
        tmpPoints[5] = tmpPoints[5] + element.points;
        setPointsData(tmpPoints);
      });
    }
    tmpPoints[6] =
      tmpPoints[0] +
      tmpPoints[1] +
      tmpPoints[2] +
      tmpPoints[3] +
      tmpPoints[4] +
      tmpPoints[5];
    setActiveStep(activeStep + 1);
    triggerRerender(!rerender);
  };

  const prevStep = () => {
    setActiveStep(activeStep - 1);
  };

  const handleSubmit = () => {
    VacancyAppRepository.updateStatus(
      vacancyApp.id,
      "BRO_CSO_SCHOOL_EVAL"
    ).then(
      (res) => {
        dispatch(
          notifyShowSuccessMessage(LOCALE.application_submited_sucessfully)
        );
        setRedirectTo("/app/commission-grading/");
      },
      (err) => {}
    );
  };

  const additionalDataRequired = () => {
    VacancyAppRepository.updateStatus(
      vacancyApp.id,
      "ADDITIONAL_DATA_REQUIRED",
      additionalDataComment,
      additionalDataDueDatePlusDays
    ).then((res) => {
      dispatch(
        notifyShowSuccessMessage(LOCALE.application_submited_sucessfully)
      );
      setRedirectTo("/app/commission-grading/");
    });
  };

  const handleClose = () => {};

  return (
    <div>
      {redirectTo && <Redirect to={redirectTo} />}
      {vacancyApp && vacancyApp.id && (
        <div>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Card>
                <CardHeader
                  color="theme"
                  style={{ padding: "8px", paddingLeft: "15px" }}
                >
                  <Typography>{LOCALE.basic_info}</Typography>
                </CardHeader>
                <CardBody>
                  <BasicInfo vacancyAppId={vacancyApp.id} disabled={true} />
                </CardBody>
              </Card>
            </Grid>
            <Grid item xs={6}>
              {" "}
              <Card>
                <CardHeader
                  color="theme"
                  style={{ padding: "8px", paddingLeft: "15px" }}
                >
                  <Typography>{LOCALE.total_points_by_domain}</Typography>
                </CardHeader>
                <CardBody>
                  <Table aria-label="table" className={classes.table}>
                    <TableBody>
                      <TableRow
                        style={
                          activeStep === 0
                            ? { background: "#eeeeee" }
                            : pointsData[0] >=
                              vacancyApp?.vacancy?.minPointsTraining
                            ? { background: "#8ddc8c" }
                            : { background: "#ff8787" }
                        }
                      >
                        <TableCell>{LOCALE.training}</TableCell>
                        <TableCell>{pointsData[0].toFixed(1)}</TableCell>
                        <TableCell>
                          {activeStep > 0 && (
                            <Icon style={{ color: "green" }}>check</Icon>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        style={
                          activeStep === 1 ? { background: "#eeeeee" } : {}
                        }
                      >
                        <TableCell>{LOCALE.professional_event}</TableCell>
                        <TableCell>{pointsData[1].toFixed(1)}</TableCell>
                        <TableCell>
                          {activeStep > 1 && (
                            <Icon style={{ color: "green" }}>check</Icon>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        style={
                          activeStep === 2 ? { background: "#eeeeee" } : {}
                        }
                      >
                        <TableCell>{LOCALE.educational_activity}</TableCell>
                        <TableCell>{pointsData[2].toFixed(1)}</TableCell>
                        <TableCell>
                          {activeStep > 2 && (
                            <Icon style={{ color: "green" }}>check</Icon>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        style={
                          activeStep === 3 ? { background: "#eeeeee" } : {}
                        }
                      >
                        <TableCell>{LOCALE.awards_and_recognition}</TableCell>
                        <TableCell>{pointsData[3].toFixed(1)}</TableCell>
                        <TableCell>
                          {activeStep > 3 && (
                            <Icon style={{ color: "green" }}>check</Icon>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        style={
                          activeStep === 4 ? { background: "#eeeeee" } : {}
                        }
                      >
                        <TableCell style={{ textTransform: "uppercase" }}>
                          {LOCALE.professional_title}
                        </TableCell>
                        <TableCell>{pointsData[4].toFixed(1)}</TableCell>
                        <TableCell>
                          {activeStep > 4 && (
                            <Icon style={{ color: "green" }}>check</Icon>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        style={
                          activeStep === 5 ? { background: "#eeeeee" } : {}
                        }
                      >
                        <TableCell>{LOCALE.authorship}</TableCell>
                        <TableCell>{pointsData[5].toFixed(1)}</TableCell>
                        <TableCell>
                          {activeStep > 5 && (
                            <Icon style={{ color: "green" }}>check</Icon>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow
                        style={
                          activeStep === 6
                            ? pointsData[6] >=
                              vacancyApp?.vacancy?.minPointsCommission
                              ? { background: "#8ddc8c" }
                              : { background: "#ff8787" }
                            : {}
                        }
                      >
                        <TableCell>
                          {LOCALE.total_points.toUpperCase()}
                        </TableCell>
                        <TableCell>{pointsData[6].toFixed(1)}</TableCell>
                        <TableCell>
                          {activeStep == 6 && (
                            <Icon style={{ color: "green" }}>check</Icon>
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </CardBody>
              </Card>
            </Grid>
          </Grid>

          {activeStep === 0 && (
            <div>
              <TrainingComponent
                gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                vacancyAppId={vacancyApp.id}
                disabled={true}
                evaluation={true}
                handleEvaluationNextStep={(data, domain) =>
                  nextStep(data, domain)
                }
              />
              <Button
                onClick={() => setDialogOpen(true)}
                color="secondary"
                size="small"
                style={{ float: "right", marginRight: "20px" }}
                variant="contained"
              >
                {LOCALE.transfer_item_for_additional_data}
              </Button>
            </div>
          )}
          {activeStep === 1 && (
            <div>
              <ProfessionalEventComponent
                gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                vacancyAppId={vacancyApp.id}
                disabled={true}
                evaluation={true}
                handleEvaluationNextStep={(data, domain) =>
                  nextStep(data, domain)
                }
              />
              <Button
                onClick={() => prevStep()}
                color="secondary"
                size="small"
                variant="contained"
              >
                {LOCALE.previous}
              </Button>
              <Button
                onClick={() => setDialogOpen(true)}
                color="secondary"
                size="small"
                style={{ float: "right", marginRight: "20px" }}
                variant="contained"
              >
                {LOCALE.transfer_item_for_additional_data}
              </Button>
            </div>
          )}
          {activeStep === 2 && (
            <div>
              <EducationalActivityComponent
                gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                vacancyAppId={vacancyApp.id}
                disabled={true}
                evaluation={true}
                handleEvaluationNextStep={(data, domain) =>
                  nextStep(data, domain)
                }
              />
              <Button
                onClick={() => prevStep()}
                color="secondary"
                size="small"
                variant="contained"
              >
                {LOCALE.previous}
              </Button>
              <Button
                onClick={() => setDialogOpen(true)}
                color="secondary"
                size="small"
                style={{ float: "right", marginRight: "20px" }}
                variant="contained"
              >
                {LOCALE.transfer_item_for_additional_data}
              </Button>
            </div>
          )}
          {activeStep === 3 && (
            <div>
              <AwardsAndRecognitionComponent
                gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                vacancyAppId={vacancyApp.id}
                disabled={true}
                evaluation={true}
                handleEvaluationNextStep={(data, domain) =>
                  nextStep(data, domain)
                }
              />
              <Button
                onClick={() => prevStep()}
                color="secondary"
                size="small"
                variant="contained"
              >
                {LOCALE.previous}
              </Button>
              <Button
                onClick={() => setDialogOpen(true)}
                color="secondary"
                size="small"
                style={{ float: "right", marginRight: "20px" }}
                variant="contained"
              >
                {LOCALE.transfer_item_for_additional_data}
              </Button>
            </div>
          )}

          {activeStep === 4 && (
            <div>
              <ProfessionalTitleComponent
                gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                vacancyAppId={vacancyApp.id}
                disabled={true}
                evaluation={true}
                handleEvaluationNextStep={(data, domain) =>
                  nextStep(data, domain)
                }
              />
              <Button
                onClick={() => prevStep()}
                color="secondary"
                size="small"
                variant="contained"
              >
                {LOCALE.previous}
              </Button>
              <Button
                onClick={() => setDialogOpen(true)}
                color="secondary"
                size="small"
                style={{ float: "right", marginRight: "20px" }}
                variant="contained"
              >
                {LOCALE.transfer_item_for_additional_data}
              </Button>
            </div>
          )}
          {activeStep === 5 && (
            <div>
              <AuthorshipComponent
                gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                vacancyAppId={vacancyApp.id}
                disabled={true}
                evaluation={true}
                handleEvaluationNextStep={(data, domain) =>
                  nextStep(data, domain)
                }
              />
              <Button
                onClick={() => prevStep()}
                color="secondary"
                size="small"
                variant="contained"
              >
                {LOCALE.previous}
              </Button>
              <Button
                onClick={() => setDialogOpen(true)}
                color="secondary"
                size="small"
                style={{ float: "right", marginRight: "20px" }}
                variant="contained"
              >
                {LOCALE.transfer_item_for_additional_data}
              </Button>
            </div>
          )}
          {activeStep === 6 && (
            <div>
              <Divider></Divider>
              <br></br>
              <Button
                color="primary"
                size="small"
                style={{ float: "right" }}
                variant="contained"
                onClick={() => handleSubmit()}
              >
                {LOCALE.save}
              </Button>
              <Button
                onClick={() => prevStep()}
                color="secondary"
                style={{ float: "left" }}
                size="small"
                variant="contained"
              >
                {LOCALE.previous}
              </Button>
              <Button
                onClick={() => setDialogOpen(true)}
                color="secondary"
                size="small"
                style={{ float: "right", marginRight: "20px" }}
                variant="contained"
              >
                {LOCALE.transfer_item_for_additional_data}
              </Button>
            </div>
          )}
        </div>
      )}
      <Dialog
        open={dialogOpen}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        PaperProps={{
          style: {
            overflowY: "unset",
          },
        }}
      >
        <CardHeader color="theme">
          <h4 className={classes.cardTitleWhite}>
            {LOCALE.transfer_item_for_additional_data}
          </h4>
        </CardHeader>
        <CardBody>
          <div>
            <DialogContent>
              <Grid item xs={12}>
                <Alert fullwidth="true" severity="info">
                  <AlertTitle>
                    {LOCALE.additional_data_info_box_title}
                  </AlertTitle>
                  {LOCALE.additional_data_info_box_text}
                </Alert>
              </Grid>
              <br />
              <Grid item xs={12}>
                <TextField
                  value={additionalDataComment}
                  label={LOCALE.comment}
                  multiline={true}
                  fullWidth={true}
                  variant="outlined"
                  rows={4}
                  onChange={(e) => setAdditionalDataComment(e.target.value)}
                />
              </Grid>
              <br />
              <Grid item xs={12}>
                <TextField
                  value={additionalDataDueDatePlusDays}
                  label={"Рок за доработка (денови)"}
                  type="number"
                  fullWidth={true}
                  variant="outlined"
                  onChange={(e) =>
                    setAdditionalDataDueDatePlusDays(e.target.value)
                  }
                />
              </Grid>
            </DialogContent>
            <Divider />
            <DialogActions>
              <Button
                size="small"
                variant="outlined"
                color="secondary"
                onClick={() => setDialogOpen(false)}
              >
                {LOCALE.cancel}
              </Button>
              <Button
                onClick={() => additionalDataRequired()}
                size="small"
                variant="contained"
                color="secondary"
              >
                {LOCALE.save}
              </Button>
            </DialogActions>
          </div>
        </CardBody>
      </Dialog>
      <br />
    </div>
  );
}
